import { Box, Stack, Typography, useTheme } from '@mui/joy';
import {
	DOLLAR_FORMATTER,
	PERCENT_FORMATTER,
	SM_PERCENT_FORMATTER
} from '../../lib/format';
import { scaleLinear } from 'd3-scale';
//import { max } from 'd3-array';
import UiTooltip from '../Controls/UiTooltip';
import ChartTooltip from './ChartTooltip';
//import { useControls } from '../../providers/ControlProvider';
import { toTitleCase } from '../../lib/utils';
//import { useRoute } from '../../providers/RouteProvider';
//import { useChartSectionData } from '../../providers/ChartSectionProvider';
import { useMediaQuery } from '../../hooks/useMediaQuery';

interface IProps {
	type: string; //'pct' | 'money'; //type of chart, either percentage or money
	office?: string;
	topic: string;
	title: string;
	maxValue?: number;
	chartData: {
		chamber: string;
		group: string;
		partyLabel: string;
		label: string;
		value: number;
		numCand: number;
	}[];
}
const SimpleDisaggChart = ({
	type,
	title,
	office,
	topic,
	maxValue,
	chartData
}: IProps) => {
	const theme = useTheme();
	//const { selectedState, election, congressTab, raceFilter } = useRoute();
	//const { maxInParty } = useChartSectionData();
	const isFiltered = true; //this is needed for chart tooltip
	const COLORS: { [key: string]: string } = {
		DEM: theme.colorSchemes.light.palette.categoryPartyDemocratWomen.solidBg,
		GOP: theme.colorSchemes.light.palette.categoryPartyRepublicanWomen.solidBg
	};
	//split rep/dem data to can align bar between charts.
	// const rep: { [x: string]: string | number }[] = chartData?.filter(
	// 	({ partyLabel }) => partyLabel === 'GOP'
	// );
	// const dem: { [x: string]: string | number }[] = chartData?.filter(
	// 	({ partyLabel }) => partyLabel === 'DEM'
	// );
	// const ind: { [x: string]: string | number }[] = chartData?.filter(
	// 	({ partyLabel }) => partyLabel === 'IND'
	// );

	//const maxValue = chartData ? max(chartData?.map((item) => item.value)) : null;
	 
	const scale: () => number = scaleLinear()
		 
		.domain([0, maxValue])
		 
		.range([0, 100]);

	// election === 'state' && page === 'state'
	// 	? office
	// 	: congressTab === 0
	// 	? 'US Senate'
	// 	: 'US House';

	//const num = 2; //num of groups to show in template
	//const spacer = 50;
	//reorder tells chart to put ind in center for radial chart sections vs at bottom for bar chart section
	//it also serves as flag for if radial or bar

	const formatValue = (value: number) => {
		if (SM_PERCENT_FORMATTER(value) === '0.00%') return '0%';
		else return SM_PERCENT_FORMATTER(value);
	};
	//console.log('test', SM_PERCENT_FORMATTER(0.000005));
	const matches = useMediaQuery(theme.breakpoints.up('md'));

	return (
		<>
			<Box
				sx={{
					flex: 1,
					margin: '1.75rem 1rem 1rem 1.5rem',
					display: 'flex',
					flexDirection: 'column'
				}}
			>
				<Box>
					<Typography
						level='subgroupTitle'
						sx={{ height: '4rem', lineHeight: '1.75rem' }}
					>
						{toTitleCase(title)}
					</Typography>

					<Typography level='chartSubtitle'>{office}</Typography>

					<Box>
						<Box
							sx={{
								// height:
								// 	(election === 'congress' || page === 'national') && !reorder
								// 		? // eslint-disable-next-line @typescript-eslint/no-unsafe-call
								// 		  `${min([maxInParty.dems + 1, 3]) * spacer}px`
								// 		: election === 'congress' || page === 'national'
								// 		? 'unset'
								// 		: `${maxInParty.dems * spacer}px`,
								transition: 'all 1s ease',
								mb: '.5rem',
								mt: '1rem'
							}}
						>
							{chartData?.map((item) => (
								<Stack
									key={item.group}
									direction={'row'}
									sx={{ lineHeight: 1.3 }}
									alignItems='center'
								>
									<UiTooltip
										key={item.group}
										title={
											<ChartTooltip
												titleText={''}
												d={item as { [x: string]: string | number }}
												topic={topic}
												isFiltered={isFiltered}
												isAnalysis={true}
											/>
										}
										variant='plain'
										sx={{ borderRadius: '0px' }}
										arrow
										placement={!matches ? 'top' : 'left'}
									>
										<Stack direction={'row'} alignItems='center'>
											{type === 'money' ? (
												<BoxChart
													item={item}
													scale={scale}
													color={COLORS[item.partyLabel]}
												/>
											) : (
												<BoxPctChart
													item={item}
													color={COLORS[item.partyLabel]}
												/>
											)}

											<Typography
												level='label'
												sx={{
													fontFamily: 'Source Sans Pro',
													fontSize: '20px',
													fontWeight: 700,
													color: COLORS[item.partyLabel],
													lineHeight: '33.6px'
												}}
											>
												{type === 'money'
													? DOLLAR_FORMATTER(+item.value)
													: +item.value < 0.01 && +item.value > 0
													? formatValue(+item.value)
													: PERCENT_FORMATTER(+item.value)}
											</Typography>
											<Typography
												level='label'
												sx={{
													fontFamily: 'Source Sans Pro',
													fontSize: '20px',
													color: COLORS[item.partyLabel],
													lineHeight: '33.6px',
													whiteSpace: 'nowrap'
												}}
											>
												&nbsp;
												{item.label}
											</Typography>
										</Stack>
									</UiTooltip>
								</Stack>
							))}
						</Box>
						{/* // ) : (
						// 	<Box sx={{ marginTop: '1rem' }} />
						// )} */}

						{/* {reorder && ind && ind.length ? (
							<Box
								sx={{
									//height: `${numDem * 64}px`,
									transition: 'all 1s ease',
									mb: '2rem'
								}}
							>
								{ind.map((item) => (
									<UiTooltip
										key={item.group}
										title={
											<ChartTooltip
												titleText={title as string}
												d={item as { [x: string]: string | number }}
												topic={topic}
												isFiltered={isFiltered}
											/>
										}
										variant='plain'
										sx={{ borderRadius: '0px' }}
										arrow
										placement={!matches ? 'top' : 'left'}
									>
										<Stack
											key={item.group}
											direction={'row'}
											sx={{ lineHeight: 1.3 }}
											alignItems='center'
										>
											{type === 'money' ? (
												<BoxChart
													item={item}
													scale={scale}
													topic={topic}
													isFiltered={isFiltered}
													title={title as string}
													print={print}
												/>
											) : (
												<BoxPctChart
													item={item}
													topic={topic}
													isFiltered={isFiltered}
													title={title as string}
													print={print}
												/>
											)}
											<Typography
												level='label'
												sx={{
													fontSize: '20px',
													fontWeight: 700,
													color: item.color,
													lineHeight: '33.6px'
												}}
											>
												{type === 'money'
													? DOLLAR_FORMATTER(+item.value)
													: +item.value < 0.01 && +item.value > 0
													? formatValue(+item.value)
													: PERCENT_FORMATTER(+item.value)}
											</Typography>
											<Typography
												level='label'
												sx={{
													fontSize: '20px',
													color: item.color,
													lineHeight: '33.6px'
												}}
											>
												&nbsp;
												{item.label}
											</Typography>
										</Stack>
									</UiTooltip>
								))}
							</Box>
						) : (
							<Box sx={{ marginTop: '1rem' }} />
						)} */}

						{/* {rep && rep.length ? (
							<Box
								sx={{
									mt: '.5rem',
									mb: '2rem',
									height: reorder
										? 'unset'
										: election === 'congress' || page === 'national'
										? // eslint-disable-next-line @typescript-eslint/no-unsafe-call
										  `${min([maxInParty.dems + 1, 3]) * spacer}px`
										: `${maxInParty.reps * spacer}px`,
									transition: 'all 1s ease'
								}}
							>
								{rep.map((item) => (
									<UiTooltip
										key={item.group}
										title={
											<ChartTooltip
												titleText={title as string}
												d={item as { [x: string]: string | number }}
												topic={topic}
												isFiltered={isFiltered}
											/>
										}
										variant='plain'
										sx={{ borderRadius: '0px' }}
										arrow
										placement={!matches ? 'top' : 'left'}
									>
										<Stack
											key={item.group}
											direction={'row'}
											sx={{ lineHeight: 1.3, alignItems: 'center' }}
										>
											{type === 'money' ? (
												<BoxChart
													item={item}
													scale={scale}
													topic={topic}
													isFiltered={isFiltered}
													title={title as string}
													print={print}
												/>
											) : (
												<BoxPctChart
													item={item}
													topic={topic}
													isFiltered={isFiltered}
													title={title as string}
													print={print}
												/>
											)}

											<Typography
												level='label'
												sx={{
													fontSize: '20px',
													fontWeight: 700,
													color: item.color,
													lineHeight: '33.6px'
												}}
											>
												{type === 'money'
													? DOLLAR_FORMATTER(+item.value)
													: +item.value < 0.01 && +item.value > 0
													? formatValue(+item.value)
													: PERCENT_FORMATTER(+item.value)}
											</Typography>
											<Typography
												level='label'
												sx={{
													fontSize: '20px',
													color: item.color,
													lineHeight: '33.6px'
												}}
											>
												&nbsp;
												{item.label}
											</Typography>
										</Stack>
									</UiTooltip>
								))}
							</Box>
						) : null}
						{!reorder && ind && ind.length ? (
							<Box
								sx={{
									//height: `${numDem * 64}px`,
									transition: 'all 1s ease',
									mb: '2rem'
								}}
							>
								{ind.map((item) => (
									<UiTooltip
										key={item.group}
										title={
											<ChartTooltip
												titleText={title as string}
												d={item as { [x: string]: string | number }}
												topic={topic}
												isFiltered={isFiltered}
											/>
										}
										variant='plain'
										sx={{ borderRadius: '0px' }}
										arrow
										placement={!matches ? 'top' : 'left'}
									>
										<Stack
											key={item.group}
											direction={'row'}
											sx={{ lineHeight: 1.3 }}
											alignItems='center'
										>
											{type === 'money' ? (
												<BoxChart
													item={item}
													scale={scale}
													topic={topic}
													isFiltered={isFiltered}
													title={title as string}
													print={print}
												/>
											) : (
												<BoxPctChart
													item={item}
													topic={topic}
													isFiltered={isFiltered}
													title={title as string}
													print={print}
												/>
											)}
											<Typography
												level='label'
												sx={{
													fontSize: '20px',
													fontWeight: 700,
													color: item.color,
													lineHeight: '33.6px'
												}}
											>
												{type === 'money'
													? DOLLAR_FORMATTER(+item.value)
													: +item.value < 0.01 && +item.value > 0
													? formatValue(+item.value)
													: PERCENT_FORMATTER(+item.value)}
											</Typography>
											<Typography
												level='label'
												sx={{
													fontSize: '20px',
													color: item.color,
													lineHeight: '33.6px'
												}}
											>
												&nbsp;
												{item.label}
											</Typography>
										</Stack>
									</UiTooltip>
								))}
							</Box>
						) : null} */}
					</Box>
				</Box>
			</Box>
		</>
	);
};

export default SimpleDisaggChart;

interface BoxProps {
	item: { [x: string]: string | number };
	scale: (arg0: number | string) => number;
	color: string;
}

const BoxChart = ({ item, scale, color }: BoxProps) => {
	return (
		<Box
			aria-label='a colored bar indicating the amount of money for a disaggregated group'
			sx={{
				width: '50px',
				height: '12px',
				position: 'relative',
				margin: '0 .5rem 0 2px'
			}}
		>
			<Box
				sx={{
					position: 'absolute',
					top: '1px',
					left: 0,
					borderRight: '2px solid black',
					width: '100%',
					height: '8px'
				}}
			></Box>
			<Box
				sx={{
					position: 'absolute',
					top: '4px',
					left: 0,
					borderTop: '2px solid black',
					width: '100%',
					height: '2px'
				}}
			></Box>
			<Box
				sx={{
					position: 'absolute',
					top: 0,
					left: 0,
					border: '1px solid black',
					width: `${scale(item.value)}%`,
					height: '10px',
					backgroundColor: color
				}}
			></Box>
		</Box>
	);
};

interface BoxPctProps {
	item: { [x: string]: string | number };
	color: string;
}
const BoxPctChart = ({ item, color }: BoxPctProps) => {
	return (
		<Box
			aria-label='a colored bar indicating the percentage of money for a disaggregated group'
			sx={{
				position: 'relative',
				width: '50px',
				height: '12px',
				margin: '0 .5rem 0 2px'
			}}
		>
			<Box
				sx={{
					width: '50px',
					height: '12px',
					position: 'absolute',
					top: 0,
					left: 0,
					border: '1px solid #333',
					backgroundColor: 'transparent',
					zIndex: 3
				}}
			></Box>
			<Box
				sx={{
					position: 'absolute',
					top: 0,
					left: 0,
					//border: '1px solid black',
					width: `${(item.value as number) * 100}%`,
					height: '12px',
					backgroundColor: color,
					zIndex: 1
				}}
			></Box>
		</Box>
	);
};
